export const SET_MODAL = 'GIFTYA/SET_MODAL';
export const SET_MODAL_RESET = 'GIFTYA/SET_MODAL_RESET';

export const setModal = data => ({
    type: SET_MODAL,
    data
});
export const setModalReset = data => ({
    type: SET_MODAL_RESET,
    data
});